module.exports = __webpack_public_path__ + "static/media/R7.bdbd5332.jpg";